var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-separator"},[_c('div',{staticClass:"block-separator__text"},[_vm._t("default")],2),_c('div',{staticClass:"block-separator__line",class:{'block-separator__line--dashed': _vm.dashed}})])}
var staticRenderFns = []

export { render, staticRenderFns }